import { getImageSrc } from '@captaincause/lib/getImageSrc'
import i18n from './i18n'
import type { Locales, ODDId } from '@captaincause/types'

interface GlobalGoalIconProps {
  id: ODDId
  locale: Locales
  size?: number
  className?: string
}

export const GlobalGoalIcon = ({
  id,
  locale,
  size = 100,
  className = '',
}: GlobalGoalIconProps) => {
  const icon: unknown = i18n[locale][id]
  if (!icon) return null

  const src = getImageSrc(icon)

  return (
    <img
      src={src}
      alt={id}
      className={className}
      width={size}
      height={size}
      loading="lazy"
    />
  )
}
